import TTSStatus from "./TTSStatus";

function getBase(state) {
  return state.tts;
}

export function getVoices(state) {
  return getBase(state).voices;
}

export function getCurrentVoiceIndex(state) {
  return getBase(state).voiceIndex;
}

export function getCurrentRate(state) {
  return getBase(state).rate;
}

export function getCurrentVoiceName(state) {
  const currentVoiceIndex = getCurrentVoiceIndex(state);
  return getVoices(state)?.[currentVoiceIndex]?.name;
}

export function getStatus(state) {
  const { playing, paused } = getBase(state).playbackStatus;
  if (paused) {
    return TTSStatus.PAUSED;
  }
  if (playing) {
    return TTSStatus.PLAYING;
  }
  return TTSStatus.STOPPED;
}

export function isAltEnabled(state) {
  return getBase(state).altEnabled;
}
